import { Context, Effect, Layer, Ref, Scope } from "effect";
import { Atom, AtomRegistry, AsyncResult } from "effect/unstable/reactivity";
import type { SurfaceCommand } from "./model.ts";

interface Registration { readonly identity: object; readonly commands: readonly SurfaceCommand[] }
export class CommandRegistry extends Context.Service<CommandRegistry, {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<readonly SurfaceCommand[]>>;
  readonly register: (surface: string, commands: readonly SurfaceCommand[]) => Effect.Effect<Effect.Effect<void>>;
}>()("workerstation/frontend/CommandRegistry") {}
export const CommandRegistryLive = (owner: Scope.Scope) => Layer.effect(CommandRegistry, Effect.gen(function* () {
  const closed = yield* Ref.make(false);
  const surfaces = yield* Ref.make<ReadonlyMap<string, Registration>>(new Map());
  const registry = yield* AtomRegistry.AtomRegistry;
  const values = yield* Ref.make<readonly SurfaceCommand[]>([]);
  const snapshot = Atom.make(Ref.get(values));
  const publish = Effect.fn("Commands.publish")(function* () { const state = yield* Ref.get(surfaces);yield* Ref.set(values, [...state.values()].flatMap(row => row.commands));yield* Effect.sync(() => registry.refresh(snapshot)); });
  yield* Effect.addFinalizer(() => Ref.set(closed, true).pipe(Effect.andThen(Ref.set(surfaces, new Map())), Effect.andThen(Ref.set(values, []))));
  return CommandRegistry.of({
    snapshot,
    register: Effect.fn("Commands.register")(function* (surface, commands) {
      if (owner.state._tag === "Closed" || (yield* Ref.get(closed))) return yield* Effect.interrupt;
      const identity = {};
      yield* Ref.update(surfaces, state => new Map(state).set(surface, { identity, commands }));yield* publish();
      return Effect.gen(function* () {
        if (owner.state._tag === "Closed" || (yield* Ref.get(closed))) return;
        const removed = yield* Ref.modify(surfaces, state => {
          if (state.get(surface)?.identity !== identity) return [false, state] as const;
          const next = new Map(state);next.delete(surface);return [true, next] as const;
        });
        if (removed) yield* publish();
      });
    })
  });
}));
